import { useMachine } from "@/queries/machine/use-machine";
import { signal } from "./message";
import { useSignal } from "./use-signal";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { useInsertScanDiagnostic } from "@/queries/tasks/use-insert-scan-diagnostic";
import { ROUTES } from "@/routes";

interface OnCompleteWOOSerialized {
  EnvelopeCategory: string;
  EnvelopeTopic: string;
  EnvelopeModule: string;
  EnvelopeTag: string;
  EnvelopeUserField1: string;
  EnvelopeUserField2: string;
  EnvelopeUserField3: string;
  EnvelopeUserField4: string;
  EnvelopeUserField5: string;
  EnvelopeUserField6: string;
  EnvelopeUserField7: string;
  EnvelopeUserField8: string;
  EnvelopeUserField9: string;
  EnvelopeUserField10: string;
  WorkOrderOperationId: string;
  EquipmentNId: string;
  SerialNumberCodeList: Array<string>;
}

function completeWOOSerialized(machineId: string) {
  return signal<{ d: [OnCompleteWOOSerialized] }>({
    app: "AppU4DM",
    channel: "OnCompleteWorkOrderOperationSerialized",
    filters: `EquipmentNId eq '${machineId}'`,
    enabled: !!machineId,
  });
}

export function useCompleteWOOSerializedSignal() {
  const { machine } = useMachine();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const { sendInsertScanDiagnostic } = useInsertScanDiagnostic();

  const machineId = machine?.EquipmentNId;

  const sendDiagnostics = (
    mtus: OnCompleteWOOSerialized["SerialNumberCodeList"]
  ) => {
    const timestamp = new Date();
    mtus.forEach((mtu) => {
      sendInsertScanDiagnostic({
        type: "Received_OnCompleteWorkOrderOperationSerialized",
        mtu,
        timestamp,
      });
    });
  };

  return useSignal(completeWOOSerialized(machineId!), ({ d }) => {
    const [msg] = d;

    sendDiagnostics(msg.SerialNumberCodeList);

    queryClient.invalidateQueries();
    navigate(ROUTES.HOME);
  });
}
